<template>
  <div>
    <div class="d-flex justify-start mt-10 mb-2">
      <h1>Expenses</h1>
    </div>
    <div v-for="(expense, index) in expenses"
         :key="index"
    >
      <ul class="mb-3">
        <li style="list-style-type: none">
          <b>{{ expense.expenseName }}</b>
          <ul style="list-style-type: square">
            <li><b>Expense Type:</b> {{ expense.expenseTypeId | getExpenseTypeLabel }}</li>
            <li><b>Amount:</b> {{ expense.amount | currency }} {{ expense.expenseAmountTypeId | getExpenseAmountType }}</li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'expenses'
  ]
}
</script>
